export default "assets/slider-arrow-c43b2042.svg";